import React, { useState } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FeedbackForm } from "../SearchPage/AISearchResultsFeedbackForm/FeedbackForm";
import styles from "../SearchPage/AISearchResultsFeedbackForm/AISearchResultsFeedbackForm.scss";
import {
  setAIFeedbackModalVisible,
  submitAIFeedback
} from "./actions";
import { selectIsAIFeedbackModalVisible } from "./selectors";
import { PageRoute } from "../../models";

export const AIFeedbackModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(selectIsAIFeedbackModalVisible);
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);

  const searchQuery = new URLSearchParams(location.search).get("searchQuery");

  const handleSubmit = async (
    isAiSearchGood: boolean,
    reasons?: number[],
    comment?: string
  ) => {
    setSubmitting(true);
    try {
      await dispatch(
        submitAIFeedback({
          isAiSearchGood,
          reasons,
          comment,
          searchQuery,
          isFrontPage:
            location.pathname === PageRoute.home
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    dispatch(setAIFeedbackModalVisible(false));
  };

  return (
    <Modal
      title="Prijavi problem s AI pretragom"
      width={520}
      footer={null}
      visible={visible}
      onCancel={handleCancel}
      className={styles.modal}
    >
      <FeedbackForm visible={visible} handleSubmit={handleSubmit} submitting={submitting} />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/containers/App/AIFeedbackModal.tsx